export const StaticNetflixChangeShoppingMall: string = "/nowelepszegoodiegalerie";
export const StaticNewNetflixShoppingMall: string = "/nowaaplikacjagalerie";
export const StaticNewNetflixShoppingMallDownloadApp: string = "/galeriezaktualizuj";
export const StaticNetflixChangeFlyers: string = "/nowelepszegoodiegazetki";
export const StaticNewNetflixFlyers: string = "/nowaaplikacjagazetki";
export const StaticNewNetflixFlyersDownloadApp: string = "/gazetkizaktualizuj";
export const StaticNetflixChangeCards: string = "/nowelepszegoodiekarty";
export const StaticNewNetflixCards: string = "/nowaaplikacjakarty";
export const StaticNewNetflixCardsDownloadApp: string = "/kartyzaktualizuj";
export const StaticNetflixChangeCashback: string = "/nowelepszegoodiecashback";
export const StaticNewNetflixCashback: string = "/nowaaplikacjacashback";
export const StaticNewNetflixCashbackDownloadApp: string = "/cashbackzaktualizuj";
export const StaticNetflixChanges: string = "/nowelepszegoodie";
export const StaticNewNetflix: string = "/nowaaplikacja";
export const StaticNewNetflixDownloadApp: string = "/zmianyzaktualizuj";
export const StaticNetflixChangeDiscounts: string = "/nowelepszegoodieznizki";
export const StaticNewNetflixDiscounts: string = "/nowaaplikacjaznizki";
export const StaticNewNetflixDiscountsDownloadApp: string = "/znizkizaktualizuj";
export const StaticGiftCard: string = "/kartapodarunkowa";
export const StaticGiftCardB2B: string = "/ekartadlafirm";
export const StaticGiftCardLP: string = "/lpkartapodarunkowa";
export const StaticGiftCardV2: string = "/lpkartapodarunkowaV2";
export const AllStaticPages: string[] = ["/nowelepszegoodiegalerie",
"/nowelepszegoodiegalerie",
"/nowaaplikacjagalerie",
"/galeriezaktualizuj",
"/nowelepszegoodiegazetki",
"/nowaaplikacjagazetki",
"/gazetkizaktualizuj",
"/nowelepszegoodiekarty",
"/nowaaplikacjakarty",
"/kartyzaktualizuj",
"/nowelepszegoodiecashback",
"/nowaaplikacjacashback",
"/cashbackzaktualizuj",
"/nowelepszegoodie",
"/nowaaplikacja",
"/zmianyzaktualizuj",
"/nowelepszegoodieznizki",
"/nowaaplikacjaznizki",
"/znizkizaktualizuj",
"/kartapodarunkowa",
"/ekartadlafirm",
"/lpkartapodarunkowa",
"/lpkartapodarunkowaV2",
]